module.exports = __webpack_public_path__ + "static/media/illustration-chat-web.4249294d.png";